export const LogoMark = ({ className = "w-8 h-8" }) => (
    <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
        <circle cx="32" cy="30" r="15" stroke="currentColor" strokeWidth="2.5" />
        <ellipse
            cx="32"
            cy="30"
            rx="27"
            ry="9"
            stroke="currentColor"
            strokeWidth="2.5"
            transform="rotate(-18 32 30)"
        />
        <path
            d="M50 10l1.3 3.1L54.5 14.5l-3.2 1.4L50 19l-1.3-3.1-3.2-1.4 3.2-1.4z"
            fill="currentColor"
        />
        <circle cx="13" cy="46" r="1.6" fill="currentColor" />
    </svg>
);

export const LogoLockup = ({ className = "" }) => (
    <div className={`flex items-center gap-3 ${className}`}>
        <LogoMark className="w-8 h-8 text-white" />
        <div className="leading-none">
            <span className="font-display font-bold tracking-[0.18em] text-white text-base block">
                WRLDKIND
            </span>
            <span className="font-mono-meta text-[9px] tracking-[0.5em] text-slate-400 block mt-1">
                STUDIOS
            </span>
        </div>
    </div>
);
